import { render } from "./ListeTypeCompte.vue?vue&type=template&id=891deff4&ts=true"
import script from "./ListeTypeCompte.vue?vue&type=script&lang=ts"
export * from "./ListeTypeCompte.vue?vue&type=script&lang=ts"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__